<template>
    <div 
        v-tinymce="options"
        @mce-change="(equipment) => offerSectionSet({equipment: equipment})"
        @mce-dirty="() => $emit('dirty')"
    >
        <div v-if="offerSections.equipment" v-html="offerSections.equipment"></div>
        <div v-else class="equipment">
            <h3>{{ $t('equipment.heading') }}</h3>
            <b-row>
                <b-col md="6">
                    <p><strong>{{ $t('equipment.preparation') }}</strong></p>
                    <p>{{ $t('equipment.requirements') }}</p>
                    <p>{{ $t('equipment.support') }}</p>
                    <ul>
                        <li>{{ $t('equipment.virtualMachines') }}</li>
                        <li>{{ $t('equipment.laptops') }}</li>
                        <li>{{ $t('equipment.cloud') }}</li>
                    </ul>
                </b-col>
                <b-col md="6">
                    <p><strong>{{ $t('equipment.materials') }}</strong><br></p>
                    <p>{{ $t('equipment.materialsDescription') }}</p>
                </b-col>
            </b-row>
        </div>
    </div>
</template>




<script>
import { mapMutations, mapGetters } from 'vuex';
export default {
    name: 'Equipment',
    props: {
        options: Object
    },
    computed: {
        ...mapGetters(['offerSections'])
    },
    methods: {
        ...mapMutations([
            'offerSectionSet',
        ])
    }
}
</script>

<style scoped>
    .equipment p {
        margin-bottom: 10px
    }
</style>
